import styled from 'styled-components';

export const TOOLBAR_TOP_HEIGHT = 40;
export const TOOLBAR_BOTTOM_HEIGHT = 45;
export const TOOLBARS_HEIGHT = TOOLBAR_TOP_HEIGHT + TOOLBAR_BOTTOM_HEIGHT;

const Container = styled.div``;

interface ToolbarBoxProps {
	invertRow?: boolean;
	zIndex?: number;
	padding?: string;
	vertical?: boolean;
}

const ToolbarBox = styled.div<ToolbarBoxProps>`
  display: flex;
  flex-direction: ${p =>
		p.vertical ? 'column' : p.invertRow ? 'row-reverse' : 'row'};
  ${({ vertical }) => (vertical ? 'width' : 'height')}: 100%;
  ${({ vertical }) => (vertical ? '' : 'max-height: 60px;')}
  display: flex;
  flex-wrap: nowrap;
  ${({ vertical }) =>
		vertical ? '' : 'align-content: center; align-items: center;'}
  gap: 8px;
  ${p => (p.zIndex ? `z-index: ${p.zIndex};` : '')}
  ${p => (p.padding ? `padding: ${p.padding};` : '')}
  ${p => {
		if (p.vertical) {
			return `
      display: grid;
      grid-template-columns: 50% 50%;
      `;
		}
		return '';
	}}
	flex-shrink: 0;
	width: fit-content;
`;

interface ToolbarImageProps {
	width?: string;
	height?: string;
	round?: boolean;
	marginLeft?: string;
	marginRight?: string;
	marginTop?: string;
	hasPointer?: boolean;
	backgroundColor?: string;
	rotate?: string;
}

const ToolbarImageContainer = styled.div<ToolbarImageProps>`
  border-radius: ${p => (p.round ? '50%' : '0%')};
  margin-left: ${p => (p.marginLeft ? p.marginLeft : '0')};
  margin-right: ${p => (p.marginRight ? p.marginRight : '0')};
  margin-top: ${p => (p.marginTop ? p.marginTop : '0')};
  cursor: ${p => (p.hasPointer ? 'pointer' : 'default')};
  transform: ${p => (p.rotate ? `rotate(${p.rotate})` : 'none')};
  ${p => (p.backgroundColor ? `background-color: ${p.backgroundColor};` : '')}
`;

export { Container, ToolbarBox, ToolbarImageContainer };
